export default "__VITE_ASSET__80640b65__"